import { BaseballLiveScoreboardAnimateMobile, BaseballLiveScoreboardDesktop, BaseballLiveScoreboardMobile, DefaultLiveScoreboardMobile, DefaultLiveScoreboardDesktop, SoccerLiveScoreboardMobile, SoccerLiveScoreboardDesktop, OnServeLiveScoreboardMobile, OnServeLiveScoreboardDesktop } from "../Live";
import { DefaultPreLiveScoreboard } from "../PreLive";
export const SportScoreboardComponents = {
    BaseballLiveScoreboardAnimateMobile,
    BaseballLiveScoreboardDesktop,
    BaseballLiveScoreboardMobile,
    DefaultLiveScoreboardMobile,
    DefaultLiveScoreboardDesktop,
    DefaultPreLiveScoreboard,
    SoccerLiveScoreboardMobile,
    SoccerLiveScoreboardDesktop,
    OnServeLiveScoreboardMobile,
    OnServeLiveScoreboardDesktop
};
//# sourceMappingURL=SportScoreboardComponents.js.map